import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import jobsReducer from './slices/jobsSlice';
import notesReducer from './slices/notesSlice';
import searchesReducer from './slices/searchesSlice';
import { setupInterceptors } from '../utils/api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    jobs: jobsReducer,
    notes: notesReducer,
    searches: searchesReducer,
  },
});

// Connect axios 401 interceptor to Redux store for automatic logout
setupInterceptors(store);
